import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { MarcaService } from "../../../../../shared/services/marca.service";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";
import { TiposerviciosDocumentosService } from "../../../../../shared/services/tiposerviciosdocumento.service";
import { Modelo, ModelosService } from "../../../../../shared/services/modelos.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbAccordion, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgbdSortableHeader } from "../../../../../shared/directives/NgbdSortableHeader";
import { ActivatedRoute } from "@angular/router";
import { Utils } from "../../../../../shared/utils/Utils";
import jsPDF from "jspdf";
declare var require;
const Swal = require("sweetalert2");
@Component({
  selector: 'app-listado-modelo',
  templateUrl: './listado-modelo.component.html',
  styleUrls: ['./listado-modelo.component.scss']
})
export class ListadoModeloComponent implements OnInit {
  @ViewChild("inputServicio") inputServicio!: ElementRef;



  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;

  sortDirection: 'asc' | 'desc' = 'asc';
  sortedColumn: string = '';

  
  formData: any = {}; // Inicializar vacío para evitar errores
  filteredTableItems: any[] = [];
  public searchText: string = ''; // Texto de búsqueda
  tipos: any;
  propietarios: any;
  formNuevo: FormGroup;
  validate: boolean = false;
  errores: any = {};
  relaciones: any;
  modelos: any;
  formTarjeta: FormGroup;
  formSoat: FormGroup;
  formCda: FormGroup;
  formExtintor: FormGroup;
  empresasaseguradora: any;
  empresascda: any;
  formBimestral: FormGroup;
  formContractual: FormGroup;
  formExtracontractual: FormGroup;
  formTodoriesgo: FormGroup;
  combustibles: any;
  editMode: boolean;
  formEmpresa: FormGroup;
  empresaselecionada: any;
  formClase: FormGroup;


  
  editarSeleccion: any;
  formConductor: FormGroup;
  botonListarDisponible: boolean = false;
  modelo: any;
  formModelo: FormGroup;
  modeloSeleccionado: any;



  // Hacer que el calendario se cierre al hacer clic fuera del componente
  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    const calendar = document.querySelector(".ngb-datepicker");
    if (calendar && !calendar.contains(event.target as Node)) {
      // Aquí el calendario se cierra automáticamente
      // Este comportamiento está controlado por autoClose='outside'
    }
  }
  constructor(
    private marcaService: MarcaService,
    private vehiclesService: VehiclesService,
    private modalService: NgbModal,
    private tiposerviciodocumentoService: TiposerviciosDocumentosService,
    private modeloService: ModelosService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }

  maxDate: string;
  minDate: string;

  ngOnInit() {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    this.minDate = formattedDate;
    this.maxDate = formattedDate;
    this.listarModelos();

  this.formModelo = this.fb.group({
  id: [null],
  modelo: [null, [Validators.required, Validators.pattern(/^\d{4}$/)]],
  estado: [1],
  usuario: ['admin'],
});
  }

  // Función para reiniciar el formulario de vehículo
  onSubmit() {
    if (this.formNuevo.valid) {
    } else {
      console.log("Formulario inválido");
    }
    if (this.formConductor.valid) {
      const conductorId = this.formConductor.value.conductor_id;
      console.log("Conductor seleccionado:", conductorId);
      // Aquí puedes proceder con la lógica para guardar o utilizar la selección
    }
  }


  Actualizar() {
    // Extraemos la propiedad placa antes de actualizar
    const vehicleData = this.formNuevo.value;
    const placa = this.editarSeleccion?.placa;

    if (!placa) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Placa no encontrada. No se puede actualizar.",
      });
      return;
    }

    if (this.editMode) {
      // **Actualizar vehículo existente**
      this.vehiclesService.updateVehicle(placa, vehicleData).subscribe({
        next: (response) => {
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "Vehículo actualizado.",
          });
        },
        error: (err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: err.message || "Error al actualizar.",
          });
        },
      });
    }
  }



  estadoDeshabilitado = true;
  


listarModelos(): void {
  this.modeloService.getModelos().subscribe({
    next: (data) => {
      this.modelos = data || []; // Asegúrate de tener siempre un arreglo
      if (this.modelos.length > 0) {
        // console.log('✅ Modelos cargados:', this.modelos);
      } else {
        console.log('⚠️ No se encontraron modelos.');
      }
      this.filteredTableItems = [...this.modelos]; // <-- Corregido: usar this.modelos
    },
    error: (error) => {
      console.error('❌ Error cargando modelos:', error);
    }
  });
}

  

  openModalModelo(content: any, id?: number) {
    console.log(id);
    if (id) {
      console.log(id);
      this.editMode = true; // Modo edición
      // Si estás buscando por `id`, asegúrate de que el servicio esté configurado para eso
      this.modeloService.getModeloById(id).subscribe({
        next: (modeloData) => {  // Cambié marcaData por modeloData
          this.modeloSeleccionado = modeloData;  // Cambié marcaSeleccionada por modeloSeleccionado
          this.formModelo.patchValue(modeloData);  // Rellenamos el formulario con los datos del modelo
          this.modalService.open(content, { size: "md", backdrop: "static" });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "No encontrado",
            text: `No se encontró un modelo con el ID ${id}.`,  // Mensaje con ID
          });
        },
      });
    } else {
       console.log(id);
      this.editMode = false; // Modo creación
      this.modeloSeleccionado = null;
      this.formModelo.reset();  // Reseteamos el formulario
      this.modalService.open(content, { size: "md", backdrop: "static" });
    }
  }
  
  

  guardarModelo() {
    // Verificar que el formulario es válido
    if (this.formModelo.invalid) {
      Swal.fire({
        icon: "error",
        title: "El campo modelo es Obligatorio",
        text: "Por favor, Ingresa un año válido.",
      });
      return;
    }
  
    // Obtener los datos del formulario y agregar el usuario de creación
    const datosModelo = {
      ...this.formModelo.value,
      usuario_creacion: "admin",  // Se puede obtener dinámicamente si se desea
    };
  
    // Verificar si estamos en modo edición
    if (this.editMode && this.modeloSeleccionado) {
      // Comparar los datos actuales con los nuevos para evitar actualización innecesaria
      const datosSinCambios = this.compararDatos(this.modeloSeleccionado, datosModelo);
  
      // Si no hay cambios, mostrar mensaje y salir
      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones en el modelo.",
        });
        return;
      }
  
      // Si hay cambios, realizar la actualización
      this.actualizarModelo(datosModelo);
    } else {
      // Si no estamos en modo edición, crear un nuevo modelo
      this.crearModelo(datosModelo);
    }
  }
  
  // Función para comparar los datos
  compararDatos(modeloSeleccionado: any, datosModelo: any): boolean {
    return JSON.stringify(modeloSeleccionado) === JSON.stringify(datosModelo);
  }
  
  // Función para actualizar el modelo
  actualizarModelo(datosModelo: any): void {
    this.modeloService.updateModelo(this.modeloSeleccionado.id, datosModelo)
      .subscribe({
        next: (respuesta) => {
          // Aquí ya hemos actualizado el modelo, entonces mostramos un mensaje de éxito
          Swal.fire({
            icon: "success",
            title: "Actualización exitosa",
            text: "Modelo actualizado correctamente.",
          });
          this.cerrarModalYRecargar();  // Cerrar el modal y recargar los datos
        },
        error: (err) => {
          this.mostrarError(err, "Error al actualizar el modelo");
        },
      });
  }
  
  // Función para crear un nuevo modelo
  crearModelo(datosModelo: any): void {
    this.modeloService.createModelo(datosModelo)
      .subscribe({
        next: (respuesta) => {
          if (respuesta.message === 'Este modelo ya está registrado.') {
            Swal.fire({
              icon: 'info',
              title: 'Modelo ya registrado',
              text: 'Este modelo ya ha sido creado anteriormente.',
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Guardado exitoso",
              text: "Modelo creado correctamente.",
            });
            this.formModelo.reset();  // Resetear el formulario
            this.cerrarModalYRecargar();  // Cerrar el modal y recargar los datos
          }
        },
        error: (err) => {
          this.mostrarError(err, "Error al guardar el modelo");
        },
      });
  }
  
  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarModelos(); // Recarga las tarjetas para la placa actual
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  actualizarEstadoAInactivo(id: number) {
    Swal.fire({
      title: "INACTIVAR MODELO",
      text: `¿Desea inactivar este modelo?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.modeloService.inactivarModelo(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Modelo inactivado!",
              text: "El estado del modelo ha sido actualizado correctamente.",
              confirmButtonText: "Aceptar",
            });
  
            this.cerrarModalYRecargar(); // Aquí recargas o actualizas la tabla o lista

          },
          error: (error) => {
            const mensaje = error?.error?.message || "No se pudo actualizar el estado del modelo";
  
            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });
  
            console.error("Error al inactivar modelo:", error);
          },
        });
      }
    });
  }
  

  
  

   exportToPDF(tableId:string,nameFile:string,titleFile:string) {
    Utils.exportToPDF(tableId, nameFile,titleFile);
    }
  
  
    exportarExcel(tableId:string,nameFile:string) {
      Utils.exportVisibleTableToExcel(tableId, nameFile);
    }
  
   
      ngOnDestroy() {
       //  this.algunObservable.unsubscribe();
    }

  sortData(column: string) {
    if (this.sortedColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }

    this.modelos.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      if (typeof valueA === 'string') {
        return this.sortDirection === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      }
    });
  }

filterData() {
  const search = this.searchText?.toLowerCase() || '';
  this.filteredTableItems = this.modelos.filter(modelo =>
    String(modelo.modelo).toLowerCase().includes(search)
  );
  this.page1 = 1; // Reinicia a la primera página al filtrar
}


}